import axios from "axios";
import {endPoints} from "..";


export const createBSPPayPaymentApi = async(reqBody) => {
  return await axios.post(`${endPoints.payments}/bsppay/save-payment`, reqBody);
};

export const processBSPPayOrderApi = async(reqBody) => {
  return await axios.post(`${endPoints.orders}/bsppay/process-order`, reqBody);
};


export const createBSPCardPaymentApi = async(reqBody) => {
  return await axios.post(`${endPoints.payments}/bspcard/save-payment`, reqBody);
};

export const processBSPCardOrderApi = async(reqBody) => {
  return await axios.post(`${endPoints.orders}/bspcard/process-order`, reqBody);
};

export const verifyHCAPTCHAApi = async (params) => {
  return await axios.post(`${endPoints.users}/hcaptcha`, params);
};

export const generatePDFReceipt = async(params) => {
  return await axios.post(endPoints.reports, params);
};